import vi from './vi'
import en from './en'
import ja from './ja'
import jp from './jp'
export default {
  en,
  vi,
  ja,
  jp
}